import axios from "axios";
import {Storage} from "@/services/Storage";
import store from "@/store";
import router from "@/router";

let getNow = function () {
    let date = new Date();
    let d = date.toISOString().split('T')[0]
    let t = date.toISOString().split('T')[1].split('.')[0];
    return d + ` ` + t;
}
const isEmpty = function (obj) {
    if (!obj) {
        return true;
    }
    return Object.keys(obj).length === 0;
}
let validateSecurity = function (security) {
    return store.dispatch(`validateSecurityPermission`, security);
}
export default {
    name: 'sales',
    state: {
        localStorageCurrentSaleLines: JSON.parse(localStorage.getItem('currentSaleLines')) || [],
        currentSale: 0,
        saleDiscount: {},
        currentSaleLines: [],
        latestInvoice: {},
        refundInv: undefined,
        discountSpecials: [],
        comboSpecials: [],
        multiSpecials: [],
        tip: 0,
        lpo: undefined,
        customer: ``,
        saleDetails: {},
    },
    getters: {
        getLatestInvoice: (state) => state.latestInvoice,
        getRefundInvoice: (state) => state.refundInv,
        getCurrentSale: (state) => state.currentSale,
        getDiscountSpecials: (state) => state.discountSpecials,
        getComboSpecials: (state) => state.comboSpecials,
        getMultiSpecials: (state) => state.multiSpecials,
        getSaleLines: (state) => state.currentSaleLines,
        getCustomer: (state) => state.customer,
        getItemSpecialPrice: (state) => (itemPLU) => {
            let specialPrice = null;

            //Discount Special
            let special = state.discountSpecials.find(sp => sp.Plu === itemPLU)
            if (special) {
                specialPrice = special.SpePrice * 1;
            }

            //Combo Special
            if (!special) {
                special = state.comboSpecials.find(sp => sp.plu === itemPLU);
                if (special) {
                    let specialID = special.special_ID;
                    let groupID = Number(special.group);
                    let otherGroup = groupID === 1 ? 2 : 1;

                    let currentSaleLines = state.currentSaleLines;
                    let otherItems = state.comboSpecials.filter(special => special.special_ID === specialID);
                    otherItems = otherItems.filter(item => Number(item.group) === otherGroup)

                    let commonItems = currentSaleLines.filter(saleLineItem =>
                        otherItems.find(otherItem => otherItem.plu === saleLineItem.Plu)
                    );

                    if (commonItems.length > 0) {
                        state.currentSaleLines = state.currentSaleLines.map(line => {
                            for (let i = 0; i < commonItems.length; i++) {
                                let otherItem = commonItems[i];
                                if (line.index === otherItem.index) {
                                    let otherItemSpecial = otherItems.find(otherItem => otherItem.plu === line.Plu)
                                    if (otherItemSpecial) {
                                        line.Unit = otherItemSpecial.Price;
                                        line.Line = otherItemSpecial.Price * line.Qty - line.Discount;
                                    }
                                }
                            }
                            return line;
                        })
                        specialPrice = special.Price;
                    }
                }
            }

            //Multi-Quantity Special
            if (!special) {
                special = state.multiSpecials.find(sp => sp.Plu === itemPLU);
                if (special) {
                    let quantity = Number(special.HowMany)
                    let price = Number(special.Price)

                    let currentSaleLines = state.currentSaleLines;
                    let saleLines = currentSaleLines.filter(line => line.Plu === itemPLU)
                        .map(saleLine => {
                            let qty = saleLine.Qty;
                            if ((qty + 1) >= quantity) {
                                specialPrice = saleLine.Unit = price;
                                saleLine.Line = price * qty;
                            }
                            return saleLine;
                        });
                    state.currentSaleLines = state.currentSaleLines.map(line => {
                        for (let i = 0; i < saleLines.length; i++) {
                            let saleLine = saleLines[i];
                            if (line.index === saleLine.index) {
                                line.Unit = saleLine.Unit;
                                line.Line = saleLine.Line;
                            }
                        }
                        return line;
                    });
                }
            }
            return specialPrice;
        },
        getTipAmount: (state) => state.tip,
        getLPO: (state) => state.lpo,
        getSaleTotal: (state) => {
            let saleLines = state.currentSaleLines;
            if (!saleLines || saleLines.length === 0) return 0.00;

            return saleLines.map(line => {
                let total = (line.Qty * line.Unit) + (line.Qty * line.tourismLevy) - line.Discount;

                // Check for instructions for each line item
                if (line.instructions && line.instructions.length > 0) {
                    let instructionTotal = line.instructions.map(i => i.Price * i.count).reduce((acc, n) => Number(n) + Number(acc), 0);
                    total += Number(instructionTotal); // Multiply by Qty to account for multiple instances
                }

                return Number(total);
            }).reduce((sum, line) => Number(sum) + Number(line), 0);
        },
        getSaleVat: (state) => {
            let saleLines = state.currentSaleLines;
            if (!saleLines || saleLines.length === 0) return 0.00;
            return saleLines.map(line => Number(line.vat)).reduce((sum, line) => Number(sum) + Number(line), 0);
        },

        getSaleDiscount: state => {
            if (!isEmpty(state.saleDiscount)) {
                return state.saleDiscount
            } else return {
                type: 'none', value: 0, total: 0
            }
        },
        getTourismLevyTotal: (state)=>{
            let saleLines = state.currentSaleLines;
            if (!saleLines || saleLines.length === 0) return 0.00;
            return saleLines.map(line => Number(line.tourismLevy * line.Qty)).reduce((sum, line) => Number(sum) + Number(line), 0);
        },
        getSaleUnits: state => state.currentSaleLines.length,
        getSubTotal: (state, getters) => {
            return getters.getSaleTotal - getters.getSaleVat
        },
        getSaleDetails: (state) => state.saleDetails,
    },
    mutations: {
        updateSaleLinePrice: async (state, data) => {
            state.currentSaleLines.map(async (line) => {
                let currentPrice = line.Unit;
                if (line.index === data.index) {
                    let stock1 = await Storage.getAllStock();
                    let item = stock1.find(stock => stock.PLU === data.Plu);
                    if (item) {
                        switch (data.priceType) {
                            case "Normal":
                                currentPrice = item.SellingIncl;
                                break;
                            case "At Cost":
                                currentPrice = item.InclCost;
                                break;
                            case "Price 1":
                                currentPrice = item.price1;
                                break;
                            case "Price 2":
                                currentPrice = item.price2;
                                break;
                            case "Price 3":
                                currentPrice = item.price3;
                                break;
                            case "Price 4":
                                currentPrice = item.price4;
                                break;
                            case "Price 5":
                                currentPrice = item.price5;
                                break;
                            default:
                                currentPrice = line.Unit;
                                break;
                        }

                    }
                }
                line.Unit = currentPrice;
                line.Line = (Number(currentPrice * Number(line.Qty)).toFixed(2) ) - line.Discount;
                return line;
            });
        },
        generateSaleUUID: (state) => state.saleUUID = generateUUID(),
        setDiscountSpecials: async (state, payload) => {
            if (!payload) payload = await Storage.getDiscountSpecials()
            state.discountSpecials = payload;
        },
        setSaleCurrency: async (state, payload) => {
            if (payload) state.saleCurrency = payload
            else state.saleCurrency = await Storage.getBaseCurrency();
        },

        setMultiSpecials: async (state, payload) => {
            if (!payload) payload = await Storage.getMultiSpecials()
            state.multiSpecials = payload;
        },

        setComboSpecials: async (state, payload) => {
            if (!payload) payload = await Storage.getComboSpecials()
            state.comboSpecials = payload;
        },

        setCurrentSale: (state, data) => state.currentSale = data,
        setSaleDetails: (state, data) => state.saleDetails = data,
        setRefundInvoice: (state, data) => {
            state.refundInv = data;
            if (data.customer) {
                state.customer = data.customer;
            }
        },
        reIndexSale:async (state) => {
            let lines = state.currentSaleLines;
            for (let i = 0; i < lines.length; i++) {
                lines[i].index = i;
            }
            state.currentSaleLines = lines;
        },
        setCurrentLines: (state, data) => state.currentSaleLines = data,
        addToCurrentSaleLines: async (state, payload) => {
            let data = payload;
            let item = state.currentSaleLines.find(line => {
                return line.Plu === data.Plu &&
                    line.Unit === data.Unit &&
                    line.Description === data.Description;
            });
            let settings = await Storage.getDeviceSettings();
            if (item && !(settings.SeperateLine) && !item.voucher) {
                item.Qty = Number(item.Qty) + Number(payload.Qty);
                item.Line = Number(payload.Unit * item.Qty - item.Discount).toFixed(2);
                const data = [...payload.instructions, ...item.instructions];
                let edited = data.reduce((accumulator, msg) => {
                    if (accumulator.has(msg.CookingNum)) {
                        let m = accumulator.get(msg.CookingNum)
                        m.count += msg.count
                    } else {
                        accumulator.set(msg.CookingNum, msg);
                    }
                    return accumulator;
                }, new Map())
                let instructions = [...edited.values()];
                instructions.map((intr, index) => {
                    if (index === 0) {
                        intr.mostRecent = true;
                    }else{
                        intr.mostRecent = false;
                    }
                    return intr;
                })
                item.instructions = instructions;
                let stockItem = await Storage.getByPlu(item.Plu);
                item.vat = await store.dispatch(`getVatAmount`, {
                    a: item.Line,
                    incl: true,
                    TaxLabels: stockItem.TaxLabels
                });
            } else {
                data.index = state.currentSaleLines.length + 1
                data.savedQty = 0;
                let stockItem = await Storage.getByPlu(data.Plu);
                data.vat = await store.dispatch(`getVatAmount`, {
                    a: data.Line,
                    incl: true,
                    TaxLabels: stockItem.TaxLabels
                });
                state.currentSaleLines.push(data);
            }
            store.commit(`reIndexSale`)
            store.dispatch(`calculateTipAmount`)
            localStorage.setItem(`currentSaleLines`, JSON.stringify(state.currentSaleLines));
        },

        voidItemTable: async (state, payload)=> {
            let validation = await validateSecurity(`Void`);
            if (!validation) return;
            let supervisor = await Storage.getSupervisor();
            let voidObj = {
                VoidPlu: payload.Plu,
                VoidDescritpiom: payload.Description,
                VoidQty: 1,
                VoidValue: payload.Unit,
                SuperVisor: supervisor, // Use the retrieved supervisor
            }
            await Storage.setSupervisor('');
            store.dispatch(`logItemVoid`, voidObj)

        },

        voidItem: async (state, payload) => {
            let item = state.currentSaleLines.find(s => s.index === payload.index)
            let validation = await validateSecurity(`Void`);
            if (!validation) return;
            let supervisor = await Storage.getSupervisor();
            let voidObj = {
                VoidPlu: item.Plu,
                VoidDescritpiom: item.Description,
                VoidQty: 1,
                VoidValue: item.Unit,
                SuperVisor: supervisor,
            }
            store.dispatch(`logItemVoid`, voidObj)
            item.Qty--;

            item.instructions = item.instructions.map((s) => {
                let msg = payload.instructions.find(m => m.CookingNum === s.CookingNum)
                if (msg) {
                    if (msg.mostRecent) {
                        if (s.count > 1) {
                            s.count -= 1
                        } else {
                            s.count -= msg.count
                        }
                    }
                }
                return s;
            });
            if (item.Qty <= 0) {
                let arr = state.currentSaleLines
                state.currentSaleLines = $utils.removeIf(arr, s => s.index !== payload.index)
            }
            store.commit(`reIndexSale`)
            await store.dispatch(`recalculateVat`)
            await store.dispatch(`calculateTipAmount`)
            localStorage.setItem(`currentSaleLines`, JSON.stringify(state.currentSaleLines));
        },

        voidLine: async (state, data) => {
            let item = state.currentSaleLines.find(s => s.index === data.index)
            let validation = await validateSecurity(`Void`);
            if (!validation) return;
            let supervisor = await Storage.getSupervisor();
            let voidObj = {
                VoidPlu: item.Plu,
                VoidDescritpiom: item.Description,
                VoidQty: item.Qty,
                VoidValue: item.Line,
                SuperVisor: supervisor,
            }
            store.dispatch(`logItemVoid`, voidObj)
            let arr = state.currentSaleLines
            state.currentSaleLines = $utils.removeIf(arr, s => {
                return s.index !== data.index;
            })
            await store.dispatch(`calculateTipAmount`)
            store.commit(`reIndexSale`)
            store.commit("voidItemLocalStorage",data)
        },
        addReceipt: (state, payload) => {
            state.latestInvoice = payload
            state.currentSaleLines = []
            state.saleDiscount = 0.00
        },
        setLPO : (state, payload) => {
            state.lpo = payload.lpoNumber;
            state.customer = payload.debtorID;
        },
        applyDiscount: (state, payload) => state.saleDiscount = payload,
        clearSale: (state) => {
            state.currentSaleLines = [];
            state.currentSale = 0;
            state.saleDiscount = undefined;
            state.tip = 0;
            state.openTableName = null;
        },
        clearDiscount: (state) => state.saleDiscount = undefined,
        /**
         * `setTipAmount` mutation — sets the tip to `data`.
         * Does NOT touch cart lines, discount, sale number or table.
         *
         * NOTE — investigation 2026-07-23 (Athena): This is the
         * reference clone mutation. Identical semantics to the Lytning
         * Restaurant POS mutation. Used by the Delivery click handler
         * (`processDelivery`) in PaymentControls.vue and NavigationBar.vue
         * to clear the tip when taking a delivery sale. Only mutates
         * `state.tip` — no other sale state is changed.
         */
        setTipAmount: (state, data) => state.tip = data,
        voidItemLocalStorage(context,newItem){
            const currentSaleLines = JSON.parse(localStorage.getItem('currentSaleLines')) || [];
            try {
                const index = currentSaleLines.findIndex(item =>
                    item.Plu === newItem.Plu &&
                    item.Description === newItem.Description
                );
                if (index !== -1) {
                    currentSaleLines.splice(index, 1);
                    localStorage.setItem('currentSaleLines', JSON.stringify(currentSaleLines));
                }
            }catch (error){
            }
        },
        setCustomer:(state, data) => state.customer = data,
    },
    actions: {
        clearLocalStorage() {
            try {
                localStorage.removeItem('currentSaleLines');
            } catch (error) {
                console.error('Error clearing local storage:', error);
            }
        },
        loadFromLocalStorage(context) {
            try {
                if (router.currentRoute.query.dontReload) return;
                const savedSaleLines = localStorage.getItem('currentSaleLines');
                if (savedSaleLines) {
                    const parsedSaleLines = JSON.parse(savedSaleLines);
                    if (parsedSaleLines && parsedSaleLines.length > 0) {
                        // Clear existing sale lines and add saved lines
                        // context.commit('clearCurrentSaleLines');
                        parsedSaleLines.forEach(line => {
                            context.commit('addToCurrentSaleLines', line);
                        });
                    }
                }
            } catch (error) {
                console.error('Error loading from local storage:', error);
            }
        },
        recalculateVat:async(context) =>{
            let lines = context.getters.getSaleLines;
            let newlines = [];
            for (let i = 0; i < lines.length; i++) {
                let lineItem = lines[i]
                lineItem.Line = (Number(lineItem.Qty) * Number(lineItem.Unit)) - Number(lineItem.Discount);
                let stockItem = await Storage.getByPlu(lineItem.Plu);
                lineItem.vat = await store.dispatch(`getVatAmount`, {
                    a: lineItem.Line,
                    incl: true,
                    TaxLabels: stockItem.TaxLabels
                });
                newlines.push(lineItem)
            }
            context.commit(`setCurrentLines`,newlines);
        },
        calculateTipAmount: async (context) => {
            let settings = await Storage.getDeviceSettings();
            let saleLines = context.getters.getSaleLines;

            let tlTotal = 0.0;
            let totalVat = 0.0;
            let saleTotal1 = context.getters.getSaleTotal;

            for (let i = 0; i < saleLines.length; i++) {
                let line = saleLines[i];
                tlTotal += (line.tourismLevy * line.Qty);
                totalVat += line.vat;
            }
            let saleTotal = saleTotal1 - context.getters.getSaleDiscount.total - tlTotal;
            if (settings && settings.AutoTip > 0) {
                let tip = Number(settings.AutoTip);
                tip = (tip / 100) * (saleTotal - totalVat);
                context.commit(`setTipAmount`, tip)
            }
        },
        parseInvoice: async (context, payload) => {
            let user = await Storage.getCurrentUser();
            let settings = await Storage.getDeviceSettings();
            let tipAmount = context.getters.getTipAmount;

            let linesDiscount = 0;

            let discountTotal = Number(context.getters.getSaleDiscount.total);

            const serviceChargeEnabled = settings && Number(settings.AutoTip) > 0 && Number(tipAmount) > 0;

            // Clone items to avoid mutating state directly
            let originalItems = context.state.currentSaleLines || [];
            let items = originalItems.map(i => ({...i}));

            // If enabled, append a non-stock service charge line as a new item
            if (serviceChargeEnabled) {
                items.push({
                    Plu: '_servicecharge',
                    Description: 'Service Charge',
                    Qty: 1,
                    Unit: Number(tipAmount),
                    Line: Number(tipAmount),
                    Discount: 0,
                    vat: 0,
                    tourismLevy: 0,
                    instructions: [],
                    nonStock: true,
                });
            }

            let total = serviceChargeEnabled ? Number(payload.total) : (Number(payload.total) - Number(tipAmount));

            for (let i = 0; i < items.length; i++) {
                let line = items[i];
                linesDiscount += Number(line.Discount || 0);
                items[i].saleLine = i + 1;
                items[i].saleline = i + 1;
                items[i].Line = ((Number(line.Qty || 0) * Number(line.Unit || 0)) + (Number(line.Qty || 0) * Number(line.tourismLevy || 0)) - Number(line.Discount || 0)).toFixed(2);
                items[i].tourismLevy = Number((Number(line.tourismLevy || 0)).toFixed(2)) * Number(line.Qty || 0);
            }
            payload.change = payload.paid - total - tipAmount;
            let invoice = {
                PC: settings.PC,
                saleNumber: context.state.currentSale,
                date: null,
                loyaltyBarcode : context.getters.getLoyaltyDetails.barcode,
                export: payload.type === `Export`,
                tot: context.getters.isTot,
                user: user.Username,
                lpo: context.state.lpo,
                reference: payload.reference ? payload.reference : ``,
                customer: context.getters.getCustomer,
                paymentType: payload.type === `Export` ? `AccountSale` : payload.type,
                items: items,
                refundReason : payload.refundReason?payload.refundReason:``,
                refundReasonCode : payload.refundReasonCode?payload.refundReasonCode:`13`,
                localId: context.state.saleUUID,
                invoice: (!payload.refund) ? 0 : payload.oldInv,
                discount: discountTotal,
                vat: (!payload.refund) ? parseFloat(context.getters.getSaleVat) : 0,
                subTotal: (!payload.refund) ? parseFloat(context.getters.getSubTotal) : parseFloat(total),
                total: parseFloat(total),
                paidAmount: (!payload.refund) ? parseFloat(payload.paid).toFixed(2) : (parseFloat(total) + Number(tipAmount)).toFixed(2),
                change: (!payload.refund) ? parseFloat(payload.change) : 0,
                units: (!payload.refund) ? context.getters.getSaleUnits : payload.items.length,
                refund: payload.refund,
                tip: serviceChargeEnabled ? 0 : Number(tipAmount),
                ...(payload.refund && { rate: payload.currencyRate }),
            };

            if (payload.type === 'Split') {
                let splitPaidTotal = 0;
                splitPaidTotal += Number(payload.splitArray.cash || 0);
                splitPaidTotal += Number(payload.splitArray.card || 0);
                splitPaidTotal += Number(payload.splitArray.Kazang || 0);
                splitPaidTotal += Number(payload.splitArray.Spenn || 0);

                if (payload.splitArray.other) {
                    for (let i = 0; i < payload.splitArray.other.length; i++) {
                        splitPaidTotal += Number(payload.splitArray.other[i].amount || 0);
                    }
                }

                invoice.paidAmount = parseFloat(splitPaidTotal);

                invoice.split = [
                    {
                        method: 'cash',
                        amount: payload.splitArray.cash
                    }, {
                        method: 'card',
                        amount: payload.splitArray.card
                    },

                    {
                        method: 'Kazang',
                        amount: payload.splitArray.Kazang
                    },

                    {
                        method: 'Spenn',
                        amount: payload.splitArray.Spenn
                    },
                ];
                if (context.getters.getHasLoyalty){
                    invoice.split.push({
                        method: 'Loyalty Program',
                        amount: payload.splitArray[`Loyalty Program`] || 0
                    })
                }
                for (let i = 0; i < payload.splitArray.other.length; i++) {
                    let method = payload.splitArray.other[i];
                    invoice.split.push({
                        method: method.name,
                        amount: method.amount
                    });
                }
            }

            if ((payload.type === 'Kazang' || (payload.type === 'Split' && payload.splitArray.Kazang > 0)) ||
                (payload.type === 'Spenn' || (payload.type === 'Split' && payload.splitArray.Spenn > 0))) {
                invoice.SecondRefrence = payload.SecondRefrence
            }

            if (payload.type === 'Kazang') {
                invoice.total += invoice.discount;
            }
            return invoice
        },
        processTransaction: async (context, payload) => {
            let isAllowed = await validateSecurity(`convertToInvoice`);
            if (!isAllowed) return false;

            if (payload.type === `AccountSale` || payload.type === `Export`) isAllowed = await validateSecurity(`AccountSale`);
            if (!isAllowed) return false;

            if (payload.type === `Cash`) isAllowed = await validateSecurity(`Cash`);
            if (!isAllowed) return false;

            if (payload.type === `Card`) isAllowed = await validateSecurity(`Card`);
            if (!isAllowed) return false;
            $utils.showLoading();
            let invoice = await context.dispatch('parseInvoice', payload)
            return context.dispatch('processInvoice', invoice)
                .then(res => {
                    if (res) {
                        localStorage.removeItem('currentSaleLines')
                        return router.push({name: 'viewPayment'});
                    }
                }).finally(() => $utils.hideLoading())
        },

        processInvoice: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let currency = await Storage.getBaseCurrency();
            return axios.post(serverApi + `invoice/${store.StoreDB}/mobile?android=true`, payload)
                .then(async ({data}) => {
                    if (typeof data === 'string') {
                        let correctedData = data.replaceAll(/NaN/g, '0');
                        data = JSON.parse(correctedData);
                    }
                    if (data.status === 200) {
                        if (data.response.zraError && isValidString(data.response.zraError)) {
                            return responses.throwErr(data.response.zraError, `Smart Invoice not Processed`)
                                .then(() => {
                                    data.response.paidAmount = 0;
                                    data.response.change = 0;
                                    return Promise.all([
                                        context.commit('setCurrentSale', 0),
                                        context.commit('setTipAmount', 0),
                                        context.commit('addReceipt', data.response),
                                        context.commit('clearDiscount'),
                                        context.commit('setSaleDetails', {}),
                                        context.commit('setCurrentSale', 0),
                                        context.commit('setCustomer', ""),
                                        context.commit('generateSaleUUID'),
                                        context.commit('setLoyaltyDetails', {}),
                                        context.commit(`setSaleCurrency`, currency),
                                        context.commit('setLPO', {
                                            debtorID: ``,
                                            lpoNumber: undefined,
                                        }),
                                        !payload.refund && context.dispatch(`printOrders`, data.response.log),
                                        context.commit('setOpenTableName', null),
                                        // Delete table from server after successful payment
                                        context.dispatch('deleteTableAfterPayment'),
                                    ]).then(() => true);
                                });
                        }
                        try {
                            context.dispatch(`BtPrint`, {invoice: data.response.invoice, reprint: false});
                        } catch (e) {
                        }
                        return Promise.all([
                            context.commit('setCurrentSale', 0),
                            context.commit('generateSaleUUID'),
                            context.commit('setTipAmount', 0),
                            context.commit('addReceipt', data.response),
                            context.commit('clearDiscount'),
                            context.commit('setSaleDetails', {}),
                            context.commit('setLoyaltyDetails', {}),
                            context.commit('setCurrentSale', 0),
                            context.commit('setCustomer', ""),
                            context.commit('setOpenTableName', null),
                            !payload.refund && context.dispatch(`printOrders`, data.response.log),
                            context.commit('setLPO', {
                                debtorID: ``,
                                lpoNumber: undefined,
                            }),
                            // Delete table from server after successful payment
                            context.dispatch('deleteTableAfterPayment'),
                        ]).then(() => {
                            Swal.close()
                            return true;
                        });
                    }

                }).catch((err) => errorHandler.tomcatError(err))
        },

        deleteTableAfterPayment: async (context) => {
            // Check if there's an open table
            const tableName = context.getters.getOpenTableName;
            if (!tableName) return;

            // Get the current sale number
            const saleNum = context.getters.getCurrentSale;
            if (!saleNum) return;

            // Find the table by sale number from the store
            const table = store.getters.getTableBySaleNum(saleNum);
            if (table) {
                // Delete the table from the server
                await store.dispatch('removeTable', table);
            }
        },

        BtPrint: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let a4 = settings.A4Inv
            if (a4) {
                let storeDB = store.StoreDB;
                return openUrl(franchiseApi + `PDFReport/getInvNum/${payload.invoice}/${storeDB}?PC=` + settings.PC);
            }
            return axios.post(printVoid + `printing/${store.StoreDB}/printReceicept/${payload.invoice}/${payload.reprint}`, settings)
                .then(({data}) => {
                    try {
                        return context.dispatch(`sendPrintToLocal`, data);
                    } catch (e) {
                        responses.showWarning(`Please update your Hardware Service`)
                        return axios.post(hardwareApi + `printing/printReceicept/${store.StoreDB}/${payload.invoice}/${payload.reprint}`, settings)
                            .catch((err) => errorHandler.tomcatError(err, false, `Print Error`))
                    }
                })
                .catch(err => errorHandler.tomcatError(err));
        },

        sendPrintToLocal: async (context, base64) => {
            if (androidMode) {
                return window.location.href = `rawbt:base64,${base64}`
            }
            let settings = await Storage.getDeviceSettings();
            if(settings.Printer){
                let obj = {
                    printer: settings.Printer,
                    base64
                }
                return axios.post(hardwareApi + 'printing/base64', obj);
            }else {
                return responses.showWarning('No printer selected')
            }

        },
        printProforma: async (context, payload) => {
            let isAllowed = await validateSecurity(`ReprintBill`);
            if (!isAllowed) return;
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            if (settings && settings.A4Inv) return openUrl(franchiseApi + `SaveTable/PrintQuote/${payload}/${store.StoreDB}`);
            return axios.post(hardwareApi + `printing/printProforma/${store.StoreDB}/${payload}/${user.Username}`, settings)
                .catch((err) => errorHandler.tomcatError(err, false, `Cannot Print Proforma Invoice`))

        },
        printBillSlip: async (context, payload) => {
            let isAllowed = await validateSecurity(`ReprintBill`);
            if (!isAllowed) return;

            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            if (settings && settings.A4Inv) return openUrl(franchiseApi + `SaveTable/PrintQuote/${payload}/${store.StoreDB}`);

            try {
                const response = await axios.post(printVoid + `printing/${store.StoreDB}/printBill/${payload}/${user.Username}`, settings);

                    if (androidMode) {
                        return window.location.href = `rawbt:base64,${response.data}`
                    }
                    if(settings.Printer){
                        let payload = {
                            printer: settings.Printer,
                            base64: response.data
                        }
                        return axios.post(hardwareApi + 'printing/base64', payload)
                    }else {
                        return responses.showWarning('No printer selected')
                    }
    
                } catch (err) {
                    errorHandler.tomcatError(err, false, `Bill Slip Print Error`)
                }


          
        },
        printBillSlipAndroid: async (context, payload) => {
            let isAllowed = await validateSecurity(`ReprintBill`);
            if (!isAllowed) return;
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let a4 = settings.A4Inv
            if (a4) {
                let storeDB = store.StoreDB;
                return openUrl(franchiseApi + `PDFReport/getInvNum/${payload.invoice}/${storeDB}?PC=` + settings.PC);
            }
            if (androidMode) {
                let user = await Storage.getCurrentUser();
                return axios.get(franchiseTomcatApi + `billPrint?Sale=${payload}&DB=${store.StoreDB}&rawBt=true&user=${user.Username}`, settings)
                    .then(({data}) => window.location.href = `rawbt:base64,${data}`)
                    .catch((err) => errorHandler.tomcatError(err, false, `Print Error`))
            }
        },
        async getAllInvoices(context, payload) {
            let store = await Storage.getDefaultStore();
            payload = {
                ...context.getters.getGlobalDateRange,
                ...payload
            }
            return axios.post(backOfficeTomcatApi + `other/${store.StoreDB}/searchSales`, payload)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

       
        async getInvoiceLines(context, inv) {
            let store = await Storage.getDefaultStore();
            return axios.get(serverApi + `invoice/${store.StoreDB}/getInvNum`, {params: {invoice: inv}})
                .then(({data}) => data).catch((err) => errorHandler.tomcatError(err))
        },
        reprintLastInvoice: async (context) => {
            let isAllowed = await validateSecurity(`Reprint`);
            if (!isAllowed) return;
            $utils.showLoading()
            let invoice = context.getters.getLatestInvoice.invoice;
            if (invoice) {
                return context.dispatch('BtPrint', { invoice: invoice, reprint: true })
                    .finally(() => $utils.hideLoading());
            }
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi + `completedsale/${store.StoreDB}/getLastInvoiceNumber`)
                .then(({ data }) => context.dispatch('BtPrint', { invoice: data, reprint: true }))
                .catch((err) => errorHandler.tomcatError(err)).finally(() => $utils.hideLoading());
        },
        openTable: async (context, tab) => {
            let store = await Storage.getDefaultStore();
            let saleNum = tab.saleNumber;
         
            try {
      
                const response = await axios.get(serverApi + `tables/${store.StoreDB}/openTable/${saleNum}`);
                if (response.status === 200) {
                    let items = tab.items.map((item, index) => {
                        item.index = index;
                        if (!item.tourismLevy) {
                            item.tourismLevy = 0;
                        }
                        item.savedQty = item.Qty;
                        return item;
                    });
                    await context.commit('setCurrentSale', tab.saleNumber);
                    await context.commit('setCurrentLines', items);
                    await context.commit('setCustomer', tab.customer);
                    if (isValidString(tab.customer)) {
                        await context.dispatch('getCustomerById', tab.customer);
                    }
                    await context.commit('setOpenTableName', tab.Name);
                    await context.dispatch('calculateTipAmount');
                  
                    return true;
                }
            } catch (err) {
                errorHandler.tomcatError(err, 'Failed to open table', store);
            }
        },
        searchCashups: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(franchiseTomcatApi + `cashup/${store.StoreDB}/search`, payload)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },

        logItemVoid: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let settings = await Storage.getDeviceSettings();
            let user = await Storage.getCurrentUser();
            payload.User = user.Username;
            payload.PC = settings.PC;
            payload.Reason = `Sale No. ${context.getters.getCurrentSale}`;
            if (settings.PrintVoid){
                await context.dispatch('printVoid',payload);
            }
            return axios.post(serverApi + `supervisorOverrides/${store.StoreDB}/logItemVoid`, payload)
                .catch(err => errorHandler.tomcatError(err, false, `Could Not Void`));
        },

        printVoid: async (context,data) => {
            let submit;
            if(!data.items){
                let items = [{
                    description: data.VoidDescritpiom,
                    plu: data.VoidPlu,
                    qty: data.VoidQty,
                    value: data.VoidValue
                }]

                submit = {
                    items,
                    pc : data.PC,
                    reason: data.Reason,
                    supervisor: data.SuperVisor,
                    user: data.User
                }

            }else {
                submit = data;
            }
            try {
                let store = await Storage.getDefaultStore();
                const response = await axios.post(printVoid + `printing/${store.StoreDB}/printVoidReceipt`, submit);
                if(androidMode){
                    return window.location.href = `rawbt:base64,${response.data}`
                }
                let settings = await Storage.getDeviceSettings();
                if(settings.Printer){
                    let payload = {
                        printer : settings.Printer,
                        base64 : response.data
                    }
                    return await axios.post(hardwareApi+'printing/base64',payload)
                }else {
                    return responses.showWarning('No printer selected')
                }
            }catch(err) {
                errorHandler.tomcatError(err, false, `Could Not Print Void`)
            }
        },

        openCashDrawer: async (context) => {
            let isAndroid = androidMode;
            if (isAndroid) return;
            let store = await Storage.getDefaultStore();
            let user = await Storage.getCurrentUser();
            let settings = await Storage.getDeviceSettings();
            return axios.post(hardwareApi + `printing/openCashdrawer/${store.StoreDB}/${user.Username}`, settings)
        },
        retrySmartInvoice: async (context, invoiceNumber) => {
            let store = await Storage.getDefaultStore()
            return axios.get(backOfficeTomcatApi + `other/${store.StoreDB}/sendSmartInvoice?invoice=` + invoiceNumber)
                .then(({data}) => data)
                .catch(err => {
                    // Handle NullPointerException for missing refund number
                    if (err.response && 
                        err.response.status === 500 &&
                        err.response.data &&
                        err.response.data.response &&
                        err.response.data.response.type &&
                        err.response.data.response.type.includes("NullPointerException") &&
                        err.response.data.response.type.includes("getRefundNumber()")) {
                        return Swal.fire({
                            title: 'Smart Invoice Error',
                            icon: 'warning',
                            html: `<p>Unable to process smart invoice due to missing refund number.</p>
                                   <p>Please contact support: +260958168829</p>`,
                            showCloseButton: true,
                        });
                    }
                    
                    const sanitizeErrorMessage = (message) => {
                        if (!message) return 'An error occurred';
                        return message.replace(/[<>]/g, match => match === '<' ? '&lt;' : '&gt;');
                    };
                    
                    if (err.response && err.response.data && err.response.data.response) {
                        const rawErrorMessage = err.response.data.response.Message || 'An error occurred';
                        const errorMessage = sanitizeErrorMessage(rawErrorMessage);
                        const errorCode = err.response.data.response.Code || err.response.data.code || '';

                        return Swal.fire({
                            title: 'Smart Invoice Error',
                            icon: 'warning',
                            html: `${errorCode ? `<p>ZRA failure Code: ${errorCode}</p>` : ''}
                                   <p>${errorMessage}</p>
                                   <p>Please contact support: +260958168829</p>`,
                            showCloseButton: true,
                        });
                    }
                    return errorHandler.tomcatError(err);
                });
        },
        getAllActiveSpecials: async (context) => {
            let store = await Storage.getDefaultStore()
            if (!store) return;
            let DB = store.StoreDB;
            return Promise.all([
                axios.get(serverApi + `specials/${DB}/getActiveSpecials?type=discount`)
                    .then(({data}) => context.commit(`setDiscountSpecials`, data)),

                axios.get(serverApi + `specials/${DB}/getActiveSpecials?type=combo`)
                    .then(({data}) => context.commit(`setComboSpecials`, data)),

                axios.get(serverApi + `specials/${DB}/getActiveSpecials?type=multi`)
                    .then(({data}) => context.commit(`setMultiSpecials`, data)),
            ])
        },

    }
}
